<script>
export default {
  name: "DetalleSLAStatus",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];

    if (val === "Cumplida") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--success el-tag--plain"
        },
        "A Tiempo"
      );
    }
    if (val == "Fallida") {
      return createElement(
        "span",
        {
          class: "el-tag el-tag--danger el-tag--plain"
        },
        "Tarde"
      );
    }
    return createElement("");
  }
};
</script>
